module.exports = __webpack_public_path__ + "static/media/day24_dynamic.2a6cbc33.gif";